<div
  class="dynamic-list-wrapper"
  [class.tablet-landscape]="
    !disableScrollableItems &&
    (deviceService.isTablet$ | async) &&
    !(deviceService.isPortrait$ | async)
  "
>
  <div class="list-scroll-container">
    <div
      class="user-card"
      *ngIf="item"
      [style.grid-template-columns]="getGridTemplate()"
      (click)="item.onClick ? item.onClick() : null"
    >
      <ng-container *ngFor="let col of columns">
        <div *ngIf="col.type === 'user'" class="user-info">
          <div class="avatar">
            <img
              *ngIf="
                item.avatarFolderPath &&
                item.avatarFolderPath.includes('base64')
              "
              [src]="item.avatarFolderPath"
              alt="{{ item[col.key] }}"
              class="rounded-circle"
            />
            <div
              *ngIf="
                !item.avatarFolderPath ||
                !item.avatarFolderPath.includes('base64')
              "
              class="no-image d-flex align-items-center justify-content-center rounded-circle amts-bg-el1"
            >
              {{ item[col.key]?.substring(0, 1)?.toUpperCase() || "?" }}
            </div>
          </div>
          <div class="details">
            <div class="name text-weight-500">
              {{ item[col.key] || "-" }}
            </div>
          </div>
        </div>

        <div
          *ngIf="col.type === 'actions'"
          class="actions-item"
          (click)="$event.stopPropagation()"
        >
          <ng-container *ngFor="let act of actions">
            <ng-container *appHasClaim="act.permission ? [act.permission] : []">
              <button
                *ngIf="!act.showIf || act.showIf(item)"
                class="btn btn-icon btn-sm"
                (click)="act.onClick(item)"
                (mouseenter)="showTooltip($event, act.title)"
                (mouseleave)="hideTooltip()"
              >
                <i [class]="act.icon"></i>
              </button>
            </ng-container>
          </ng-container>
        </div>

        <div
          *ngIf="col.type !== 'user' && col.type !== 'actions'"
          class="data-item"
        >
          <span class="data-label">{{ col.labelKey | translate }}</span>

          <span
            class="data-value"
            [ngClass]="col.cssClass ? col.cssClass(item) : ''"
          >
            <ng-container [ngSwitch]="col.type">
              <span *ngSwitchCase="'date'">{{
                (resolveValue(col, item) | date: "dd.MM.yyyy") || "-"
              }}</span>
              <span *ngSwitchDefault>{{
                resolveValue(col, item) | translate
              }}</span>
            </ng-container>
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Custom tooltip element -->
  <div
    class="risk-tooltip"
    *ngIf="activeTooltip"
    [style.left.px]="activeTooltip.x"
    [style.top.px]="activeTooltip.y"
  >
    {{ activeTooltip.text }}
  </div>
</div>
